import { STATUS } from "../../../../../../ui/StatusLabel/constants/status";
import { SEARCH_RESULT_STATUS_MAP } from "../../../../constants/searchResultStatusMap";

import type { GoodsSearchResultItem } from "../../../../types/goodsSearchResultItem";
import type { LegacyPortalSearchResultGoods } from "@spwn-portal/grpc";

type Input = LegacyPortalSearchResultGoods;
type Output = GoodsSearchResultItem;
type ConvertResponse = (input: Input) => Output;

export const convertResponse: ConvertResponse = (input) => {
  const { id, name, priceJpy, relativeGoodsUrl, seller, status, thumbnail } =
    input;
  const returnValue: GoodsSearchResultItem = {
    defaultImage: thumbnail,
    goodsUrl: relativeGoodsUrl,
    id,
    name,
    price: priceJpy,
    seller,
    status: SEARCH_RESULT_STATUS_MAP[status] ?? STATUS.NO_LABEL,
  };
  return returnValue;
};
